// Pure helpers for the call room. The LiveKit connection stays in the Stimulus controller.

export function parseChatMessage(raw) {
  let data
  try {
    data = JSON.parse(raw)
  } catch {
    return null
  }
  if (!data || typeof data.text !== "string") return null
  const text = data.text.trim().slice(0, 2000)
  if (!text) return null
  const sender = String(data.sender || "").trim().slice(0, 80)
  return { sender, text }
}

export function chatPayload(sender, text) {
  const message = parseChatMessage(JSON.stringify({ sender, text }))
  if (!message) return null
  return JSON.stringify(message)
}
